import { memo } from 'react';
import { GridCellParams } from '@mui/x-data-grid';
import clsx from 'clsx';
import { Date, DelayedDays, Root, PendingText } from './styles';

export interface ForecastProps {
  date: string;
  delayedDays: number;
}

const Forecast = memo((props: ForecastProps) => {
  const { date, delayedDays } = props;

  return (
    <Root>
      <Date>{`${date}`}</Date>
      <DelayedDays
        className={clsx({
          late: delayedDays > 0,
          inAdvance: delayedDays < 0,
        })}
      >
        {delayedDays > 0 && `${delayedDays} dia(s) atrasado(s)`}
        {delayedDays < 0 && `${-delayedDays} dia(s) adiantado(s)`}
      </DelayedDays>
    </Root>
  );
});

const Pending = () => (
  <Root>
    <PendingText>PENDENTE</PendingText>
  </Root>
);

export function renderForecast(params: GridCellParams): JSX.Element {
  if (params.row.sipacId) {
    return (
      <Forecast date={(params.value as ForecastProps).date} delayedDays={(params.value as ForecastProps).delayedDays} />
    );
  }
  return <Pending />;
}
